// All the logic that has to do with displaying apartment fields.

import { sprintf } from "sprintf-js";

import translate from "../../lib/translate";
import globals from "../../lib/globals";
import {
  formatStringDecimal,
  formatStringArea,
  formatStringInt,
} from "../../lib/format";

export default {
  methods: {
    apartmentDisplayType: function (apartment) {
      return {
        rental: "Vuokra (asuntotyyppi)",
        "right-of-occupancy": "ASO",
        "owner-occupancy": "Omistus",
      }[apartment.type];
    },
    apartmentDisplayPriceTitle: function (apartment) {
      return {
        rental: "Vuokra",
        "right-of-occupancy": "Vastike",
        "owner-occupancy": "Velaton hinta",
      }[apartment.type];
    },
    apartmentDisplayPrice: function (apartment) {
      const priceByType = {
        rental: apartment.dg_vastikealennus ?
          String(Math.round((Number(apartment.mpc_vuokra) - Number(apartment.dg_vastikealennus)) * 100) / 100) :
          apartment.mpc_vuokra,
        "right-of-occupancy": apartment.dg_vastikealennus ?
          String(Math.round((Number(apartment.mpc_vastike) - Number(apartment.dg_vastikealennus)) * 100) / 100) :
          apartment.mpc_vastike,
        "owner-occupancy": apartment.ava_Velatonhinta,
      };

      if (!priceByType[apartment.type]) {
        return "-";
      }

      if (apartment.type === "owner-occupancy") {
        return `${formatStringInt(priceByType[apartment.type])} €`;
      } else {
        return `${formatStringDecimal(
          priceByType[apartment.type]
        )} €/${translate("kk")}`;
      }
    },
    apartmentDisplayColor: function (apartment) {
      return (
        {
          rental: "green",
          "right-of-occupancy": "green",
          "owner-occupancy": "green",
        }[apartment.type] || false
      );
    },
    apartmentDisplayClassBadge: function (apartment, modifiers = []) {
      const color = this.apartmentDisplayColor(apartment);
      return [
        "btn",
        "btn--round",
        color ? `btn--${color}` : null,
        ...modifiers,
      ];
    },
    apartmentDisplayAvailable: function (apartment, fullSentences = false) {
      const strConstructionDate = apartment.housing_locality.mpc_valmistumispaiva;
      const dateConstructionDate = new Date(strConstructionDate);
      if (new Date() <= dateConstructionDate) {
        const strDateConstructionLocalized = dateConstructionDate.toLocaleDateString(globals.language);
        return fullSentences
          ? sprintf(translate("Arvioitu valmistuminen %s"), strDateConstructionLocalized)
          : strDateConstructionLocalized;
      }
      if (!apartment.availableInFuture) {
        return fullSentences ? translate("Heti vapaa") : translate("Heti");
      }
      const string = apartment.mpc_vapautumispvm;
      const date = new Date(string);
      const stringLocalized = date.toLocaleDateString(globals.language);
      return fullSentences
        ? sprintf(translate("Vapautuu %s"), stringLocalized)
        : stringLocalized;
    },
    apartmentDisplayShowing: function (apartment) {
      if (!apartment.showingInFuture) {
        return null;
      }

      const date = new Date(apartment.mpc_esittelypaiva);
      const formattedDate = date.toLocaleDateString(globals.language);
      const startTime = apartment?.mpc_esittelyalkaa ?
        sprintf(translate("klo %s"), apartment.mpc_esittelyalkaa) :
        '';

      // fi: 14.2.2025 klo 15:00
      return formattedDate + (startTime ? ' ' + startTime : '' );
    },
    apartmentDisplayLocation: function (apartment) {
      const parts = [];

      if (apartment.township) {
        parts.push(apartment.township.name);
      }

      if (apartment.city) {
        parts.push(apartment.city.mpc_name);
      }

      return parts.join(", ");
    },
    apartmentDisplayArea(apartment, withUnit = true) {
      return formatStringArea(apartment.mpc_pinta_ala, withUnit);
    },
    apartmentDisplayFloor(apartment) {
      if (apartment.mpc_kerros === null) return;
      return `, ${apartment.mpc_kerros}. ${translate("Kerros").toLowerCase()}`;
    },
    apartmentDisplaySellPrice(apartment) {
      if (apartment.type !== "owner-occupancy") return;
      return `${formatStringInt(apartment.ava_Myyntihinta)} €`;
    },
  },
};
